module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/locked-folder-26662e8f169fae29e495ccc74e7d4359.svg";